module.exports = __webpack_public_path__ + "img/EPS.6db8860d.svg";